import { environment } from './../../environments/environment.local';
import { ParseAdapter } from '../abstract/ParseAdapter';
import { Vehicle } from './vehicle.model';
import { Device } from './device.model';
import { TchekImage } from './image';

export enum TchekStatus {
    LOADING,
    UNREAD,
    READ,
    CLOSED,
    LITIGATION,
    INSPECTED
}

export enum TchekType {
    tchekBasic,
    tchekOne,
    tchekLite,
    tchek360,
    tchekApp,
}


export class Tchekb extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }


    get type(): TchekType { return this.parseObject.get('type') ? this.parseObject.get('type') : 0; }
    set type(value: TchekType) { this.parseObject.set('type', value); }

	get resultAltoApi(): any { return this.parseObject.get('resultAltoApi')  }
    set resultAltoApi(value: any) { this.parseObject.set('resultAltoApi', value); }


    get immatPicture(): boolean { return this.parseObject.get('immatPicture') }
    set immatPicture(value: boolean) { this.parseObject.set('immatPicture', value); }

    get thumbnailPicture(): boolean { return this.parseObject.get('thumbnailPicture') }
    set thumbnailPicture(value: boolean) { this.parseObject.set('thumbnailPicture', value); }

    get inspectedByAlto(): boolean { return [4,5,2].includes(this.parseObject.get('type'))}
    set inspectedByAlto(value: boolean) { this.parseObject.set('inspectedByAlto', value); }

    get toDownload(): number { return this.parseObject.get('toDownload'); }
    set toDownload(value: number) { this.parseObject.set('toDownload', value); }

    get objectDetected(): { [type: string]: number } { return this.parseObject.get('objectDetected'); }
    set objectDetected(value: { [type: string]: number }) { this.parseObject.set('objectDetected', value); }

    get vehiclePtr(): Vehicle { return new Vehicle(this.parseObject.get('vehiclePtr')); }
    set vehiclePtr(value: Vehicle) { this.parseObject.set('vehiclePtr', value.getParseInstance()); }

    get path(): string { return this.parseObject.get('path'); }
    set path(value: string) { this.parseObject.set('path', value); }

     get isUploaded(): boolean { return this.parseObject.get('isUploaded'); }
    set isUploaded(value: boolean) { this.parseObject.set('isUploaded', value); }

    get webObjectId(): string { return this.parseObject.get('webObjectId'); }
    set webObjectId(value: string) { this.parseObject.set('webObjectId', value); }

    get detectionStatus(): boolean { return this.parseObject.get('detectionStatus'); }
    set detectionStatus(value: boolean) { this.parseObject.set('detectionStatus', value); }

    get way(): boolean { return this.parseObject.get('way'); }
    set way(value: boolean) { this.parseObject.set('way', value); }

    get isDeleted(): boolean { return this.parseObject.get('isDeleted'); }
    set isDeleted(value: boolean) { this.parseObject.set('isDeleted', value); }

    get toAnalyze(): boolean { return this.parseObject.get('toAnalyze'); }
    set toAnalyze(value: boolean) { this.parseObject.set('toAnalyze', value); }

    get scanToUpload(): boolean { return this.parseObject.get('scanToUpload'); }
    set scanToUpload(value: boolean) { this.parseObject.set('scanToUpload', value); }

    get inspected(): boolean { return this.parseObject.get('inspected'); }
    set inspected(value: boolean) { this.parseObject.set('inspected', value); }

    get kpi(): boolean { return this.parseObject.get('kpi'); }
    set kpi(value: boolean) { this.parseObject.set('kpi', value); }

    get isFlagged(): boolean { return this.parseObject.get('isFlagged'); }
    set isFlagged(value: boolean) { this.parseObject.set('isFlagged', value); }

    get videoConverter(): number { return this.parseObject.get('videoConverter'); }
    set videoConverter(value: number) { this.parseObject.set('videoConverter', value); }

    get uploadHDPictures(): boolean { return this.parseObject.get('uploadHDPictures'); }
    set uploadHDPictures(value: boolean) { this.parseObject.set('uploadHDPictures', value); }

    get isDeletedLocal(): boolean { return this.parseObject.get('isDeletedFromLocal'); }
    set isDeletedLocal(value: boolean) { this.parseObject.set('isDeletedFromLocal', value); }

    get isHDLocal(): boolean { return this.parseObject.get('isHD'); }
    set isHDLocal(value: boolean) { this.parseObject.set('isHD', value); }

    get isAnnotated(): boolean { return this.parseObject.get('isAnnotated'); }
    set isAnnotated(value: boolean) { this.parseObject.set('isAnnotated', value); }

    get percentDamage(): number { return parseInt(this.parseObject.get('percentDamage'), 10); }
    set percentDamage(value: number) { this.parseObject.set('percentDamage', value.toString()); }

    get isNew(): boolean { return this.parseObject.get('isNew'); }
    set isNew(value: boolean) { this.parseObject.set('isNew', value); }

    get toSync(): boolean { return this.parseObject.get('toSync'); }
    set toSync(value: boolean) { this.parseObject.set('toSync', value); }

    get probabilityVehicle(): number { return this.parseObject.get('probabilityVehicle'); }
    set probabilityVehicle(value: number) { this.parseObject.set('probabilityVehicle', value); }

    get status(): TchekStatus { return this.parseObject.get('status'); }
    set status(value: TchekStatus) { this.parseObject.set('status', value); }

    get detectionFinished(): boolean { return this.parseObject.get('detectionFinished'); }
    set detectionFinished(value: boolean) { this.parseObject.set('detectionFinished', value); }

    get devicePtr(): Device { if (this.parseObject && this.parseObject.get('devicePtr')) return new Device(this.parseObject.get('devicePtr')); }
    set devicePtr(value: Device) { this.parseObject.set('devicePtr', value.getParseInstance()); }

    get isHash(): boolean { return this.parseObject.get('isHash'); }
    set isHash(value: boolean) { this.parseObject.set('isHash', value); }

    get otsIsUpload(): boolean { return this.parseObject.get('otsIsUpload'); }
    set otsIsUpload(value: boolean) { this.parseObject.set('otsIsUpload', value); }

    get percentParts(): string { return this.parseObject.get('percentParts'); }
    set percentParts(value: string) { this.parseObject.set('percentParts', value); }

    get tchekCreatedAt(): Date { return this.parseObject.get('tchekCreatedAt'); }
    set tchekCreatedAt(value: Date) { this.parseObject.set('tchekCreatedAt', value); }

    get reportOpen(): number { return this.parseObject.get('reportOpen'); }
    set reportOpen(value: number) { this.parseObject.set('reportOpen', value); }

    get playerOpen(): number { return this.parseObject.get('playerOpen'); }
    set playerOpen(value: number) { this.parseObject.set('playerOpen', value); }

    get fre(): number { return this.parseObject.get('fre'); }
    set fre(value: number) { this.parseObject.set('fre', value); }

    get newFre(): number { return this.parseObject.get('newFre'); }
    set newFre(value: number) { this.parseObject.set('newFre', value); }

    get speed(): number { return Math.round(this.parseObject.get('speed') * 100) / 100; }
    set speed(value: number) { this.parseObject.set('speed', value); }

    get numberDamage(): number { return this.parseObject.get('numberDamage'); }
    set numberDamage(value: number) { this.parseObject.set('numberDamage', value); }

    get numberNewDamage(): number { return this.parseObject.get('numberNewDamage'); }
    set numberNewDamage(value: number) { this.parseObject.set('numberNewDamage', value); }

    get picturesSelected(): PicturesSelected { return this.parseObject.get('picturesSelected'); }
    set picturesSelected(value: PicturesSelected) { this.parseObject.set('picturesSelected', value); }

    get severityVehicleParts(): SeverityVehicleParts[] { return this.parseObject.get('severityVehicleParts'); }
    set severityVehicleParts(value: SeverityVehicleParts[]) { this.parseObject.set('severityVehicleParts', value); }

    get camConfig(): object { return this.parseObject.get('camConfig'); }
    set camConfig(value: object) { this.parseObject.set('camConfig', value); }

    get forValidation(): boolean { return this.parseObject.get('forValidation'); }
    set forValidation(value: boolean) { this.parseObject.set('forValidation', value); }

    get damageControl(): number { return this.parseObject.get('damageControl'); }
    set damageControl(value: number) { this.parseObject.set('damageControl', value); }

    get underbody(): boolean { return (this.parseObject.get('underbodyStatus') === 'uploaded' || (this.parseObject.get('underbodyStatus') === 'created' && environment.isLocal)); }
    set underbody(value: boolean) { this.parseObject.set('underbodyStatus', value); }

    get thumbnailImagePtr(): TchekImage {
        if (this.parseObject.get('thumbnailImagePtr'))
            return new TchekImage(this.parseObject.get('thumbnailImagePtr'))
        else return undefined
    }
    set thumbnailImagePtr(value: TchekImage) { this.parseObject.set('thumbnailImagePtr', value); }


}

export class TchekImages extends Tchekb {
    constructor(parseObject: Parse.Object, images: TchekImage[]) {
        super(parseObject);
        this.images = images || [];
    }
    images: TchekImage[]
}

export interface SeverityVehicleParts {
    location: string;
    severity: string;
    severityType: string;
    cost: number;
    costType: string,
}
interface picture {
    camera: number,
    picture: number
}
interface PicturesSelected {
    FL: picture,
    FR: picture,
    BR: picture,
    BL: picture
}


export class PicturesSelectedTchek extends Tchekb {
    picturesSelectedUrl: string[];
    constructor(parseObject: Parse.Object, urlObj?: string[]) {
        super(parseObject);
        this.picturesSelectedUrl = urlObj;
    }
}
export class HydratedTchek extends Tchekb {
    thumbnailUrl: string;
    immatUrl: string

    constructor(parseObject: Parse.Object, thumbnailUrl?: string, immatUrl?: string) {
        super(parseObject);
        this.thumbnailUrl = thumbnailUrl;
        this.immatUrl = immatUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/tchekb.model.ts